import { TABLET_WIDTH, TABLET_HEIGHT } from "../config/consts";

export const checkScreenSizeIfMobile = () => {
    const { clientWidth, clientHeight } = document.documentElement;
    return clientWidth < TABLET_WIDTH || clientHeight < TABLET_HEIGHT;
};
